/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Deactivate_ConfirmInputs */

const en_users_deactivate_confirm = /** @type {(inputs: Users_Deactivate_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deactivate`)
};

const pt_br2_users_deactivate_confirm = /** @type {(inputs: Users_Deactivate_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desativar`)
};

/**
* | output |
* | --- |
* | "Deactivate" |
*
* @param {Users_Deactivate_ConfirmInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_deactivate_confirm = /** @type {((inputs?: Users_Deactivate_ConfirmInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Deactivate_ConfirmInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_deactivate_confirm(inputs)
	return pt_br2_users_deactivate_confirm(inputs)
});